import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import ZHLRateCards$1 from '@zillow/zhl-rate-card';
import React from 'react';

var RateCardsBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs,
      blockData = _ref.blockData;
    return /*#__PURE__*/React.createElement(ZHLRateCards$1, _extends({
      data: blockData
    }, attrs));
  },
  metadata: {
    name: 'zhl/zhl-rate-cards',
    title: 'ZHL Rate Cards',
    description: 'Set of rate cards for ZHL',
    icon: 'editor-table',
    category: 'more',
    keywords: ['zhl', 'loan', 'rate', 'cards'],
    attributes: {
      blueCardButtonText: {
        type: 'string',
        control: 'text',
        default: 'Get your personalized rate',
        description: 'Text for the blue card button',
        label: 'Blue Card Button Text'
      },
      blueCardLink: {
        type: 'string',
        control: 'text',
        default: 'https://www.zillow.com/',
        description: 'Link for the blue card button',
        label: 'Blue Card Link'
      },
      blueCardText: {
        type: 'string',
        control: 'text',
        default: "Mortgage rates aren't one size fits all. We can give you an estimate based on your unique details.",
        description: 'Text for the blue card',
        label: 'Blue Card Text'
      },
      blueCardImage: {
        type: 'string',
        control: 'text',
        default: 'https://delivery.digitalassets.zillowgroup.com/api/public/content/SZ_STUDIO_B2CPA_LA_Edeani_2024_Colonial_Ext_Porch_0500_rgb_768x360?v=d326909e',
        description: 'Image link to be displayed in custom card',
        label: 'Blue Card Image URL'
      },
      whiteCardButtonLink: {
        type: 'string',
        control: 'text',
        default: 'https://www.zillow.com/',
        description: 'White cards and modal button link',
        label: 'White Card Button Link'
      },
      showDesc: {
        type: 'boolean',
        control: 'boolean',
        default: false,
        description: 'Display card description',
        label: 'Show Description'
      },
      tabbed: {
        type: 'boolean',
        control: 'boolean',
        default: false,
        description: 'Whether to show the rate cards in tabbed format',
        label: 'Show tabbed elements'
      },
      whiteCardModalButtonText: {
        type: 'string',
        control: 'text',
        default: 'See sample loan terms',
        description: 'Text for the white card modal button',
        label: 'White Card Modal Button'
      },
      whiteCardsButtonText: {
        type: 'string',
        control: 'text',
        default: 'Get Pre-Approved',
        description: 'Text for the white cards button',
        label: 'White Cards Button Text'
      }
    }
  },
  getBlockData: function getBlockData() {
    return new Promise(function ($return, $error) {
      var apiUrl, apiKey, response, data;
      apiUrl = process.env.ZHL_RATES_API_URL + '/zhlRatePage/states/CA';
      apiKey = process.env.ZHL_RATES_API_KEY;
      var $Try_1_Catch = function (error) {
        try {
          console.error('Error fetching data:', error);
          return $return(null);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(fetch(apiUrl, {
          method: 'GET',
          headers: {
            apiKey: apiKey
          }
        })).then(function ($await_2) {
          try {
            response = $await_2;
            return Promise.resolve(response.json()).then(function ($await_3) {
              try {
                data = $await_3;
                return $return(data);
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }, $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error);
      }
    });
  }
};
var ZHLRateCards = RateCardsBlock;

export { ZHLRateCards as default };
